module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centerf"
  }, [_c('a', {
    attrs: {
      "id": "ch01dairy"
    }
  }, [_vm._v("From "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Diary of Trevor")])])]), _c('a', {
    attrs: {
      "id": "ch01dairy"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "ch01dairy"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("I like the new teacher. I don’t know what the deal is with the other kids in my class. Even Joe, who’s my friend. They all just stared at him like he was from outer space. At least Joe didn’t laugh when Mr. St. Clair wasn’t looking.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("And the weird thing is, I don’t think most of it was his face. I mean, it was. At first. But then he started talking, and you could sort of feel that almost everybody got used to it. A little.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But then he wrote that assignment on the board. He wrote it in really big capital letters, like the blackboard was yelling at us.")]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("THINK OF AN IDEA FOR WORLD CHANGE AND PUT IT INTO ACTION")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Man, was it ever quiet in that room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, Jamie, this girl who’s usually really shy, said, “Um. What is that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. St. Clair said, “It’s an assignment. For extra credit.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More silence.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("This guy named Jack, who’s much cooler than me and has lots more friends, said, “We’re supposed ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("to change the world for social studies class? Isn’t that a little . . . hard?”")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re supposed to think of an idea that might change the world and set it in motion. Whether or not the world actually changes is not part of the assignment.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then Arnie, who always likes trouble, said, “That’s still the hardest assignment anybody ever gave us. We’re a bunch of kids. What do you want from us?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want you to think,” Mr. St. Clair said. “The first word in this assignment is ‘think.’ So far you’re arguing. Not thinking. That said, if it feels like too much, bear in mind it’s for extra credit. It’s not required.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But I already totally knew I was going to do it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked around at all the kids in my class. I had to look over one shoulder at a time, because I always sit in the front row. Everybody was just staring at that sentence on the board. Some of the kids looked like they were concentrating, but frowning. And then two of the guys looked away and started whispering to each other, like something was funny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at my friend Joe, but he just looked totally confused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wondered if I was the only one who was going to give the assignment a try. And, if so, why.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8acb10ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01dairy.vue
// module id = 69
// module chunks = 0